import { useEffect, useRef, useCallback } from "react";
import { useDeviceDetection } from "./useDeviceDetection";

export const useAutoClosePanel = ({
  panelRef,
  isOpen,
  onClose,
  delay = 5000,
}) => {
  const timerRef = useRef(null);
  const isHoveringRef = useRef(false);
  const { isMobile } = useDeviceDetection();

  /* ------------------------------
     Timer helpers
  ------------------------------ */
  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startTimer = useCallback(() => {
    clearTimer();
const delayMaj = isMobile ? delay * 1.5 : delay;
    timerRef.current = setTimeout(
      () => {
        if (!isHoveringRef.current) {
          onClose();
        }
      },
      delayMaj,
    );
  }, [clearTimer, onClose, delay,isMobile]);

  /* ------------------------------
     Start / stop timer on open
  ------------------------------ */
  useEffect(() => {
    if (!isOpen) {
      clearTimer();
      isHoveringRef.current = false;
      return;
    }

    startTimer();

    return clearTimer;
  }, [isOpen, startTimer, clearTimer]);

  /* ------------------------------
     Hover pause / resume
  ------------------------------ */
  useEffect(() => {
    if (!isOpen || isMobile) return;

    const panel = panelRef.current;
    if (!panel) return;

    const handleMouseEnter = () => {
      isHoveringRef.current = true;
      clearTimer();
    };

    const handleMouseLeave = () => {
      isHoveringRef.current = false;
      startTimer();
    };

    panel.addEventListener("mouseenter", handleMouseEnter);
    panel.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      panel.removeEventListener("mouseenter", handleMouseEnter);
      panel.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [panelRef, isOpen, isMobile, startTimer, clearTimer]);

  /* ------------------------------
     Click outside / scroll / resize
  ------------------------------ */
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleScroll = () => onClose();
    const handleResize = () => onClose();

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [panelRef, isOpen, onClose]);

  /*

  console.log("useAutoClosePanel render", { isOpen });

useEffect(() => {
  console.log("AUTO CLOSE EFFECT", { isOpen });

  if (!isOpen) {
    clearTimer();
    isHoveringRef.current = false;
    return;
  }

  startTimer();

  return clearTimer;
}, [isOpen, startTimer, clearTimer]);
*/
};
